<!--
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-24 10:52:21
 * @FilePath: /insuranceagent-ui/src/components/insurance/excelDialog.vue
 * @Description: 上传excel文件
-->
<template>
	<base-form-dialog
		ref="refBaseCard"
		formOptionNumTemp="9"
		is-form
		is-show-close
		:title="title"
		width="40%"
		@onSendFileList="onGetFileList"
		@onUploadAfter="onUploadAfter"></base-form-dialog>
</template>

<script>
import BaseFormDialog from '@/components/insurance/baseFormDialog.vue'
import {importSettlePlan} from '@/api/insurance/settlement'

export default {
	name: 'excelDialog',
	components: {BaseFormDialog},
	props: {
		title: {
			type: String,
			default: '',
		},
		interType: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			addIdNoInterval: null,
			//查询次数
			queryCount: 0,
		}
	},
	beforeDestroy() {},
	methods: {
		show() {
			this.$refs['refBaseCard'].show()
		},
		onUploadAfter(res = {}, done, loading) {},
		async onGetFileList(fileList) {
			try {
				//调用接口
				let {type, url} = this.getRequestData()
				let formData = new FormData()
				formData.append(type, fileList[0])
				let res = (await importSettlePlan({data: formData, url})) || {}
				if (res.data.code === 0) {
					this.$message.success('导入成功')
				}
			} catch (error) {
			} finally {
				//判断是否为空
				if (this.$refs.refBaseCard) {
					this.$refs.refBaseCard.onClearFileList()
					this.$refs.refBaseCard.isShowFormLoading(false)
				}
			}
		},
		getRequestData() {
			switch (this.interType) {
				case 'importSettlePlan':
					return {
						type: 'file',
						url: '/dist/settle/plan/import',
					}
				default:
					break
			}
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
	margin-left: 0 !important;
}

::v-deep .el-dialog--center .el-dialog__body {
	text-align: center;
}
</style>
